export default __webpack_public_path__ + "static/media/reports.cd4738a9.png";